import { getContent } from '../../../shared/content.js';
import type { UseCasePage } from '../../../shared/content-types.js';
import { Blocks } from '../../components/RichText.js';
import { useLocale } from '../../i18n.js';
import { AdSlot } from '../AdSlot.js';
import { UseCaseCta } from '../UseCaseCta.js';

/**
 * Shared shell for the three use-case guides.
 *
 * The pages differ only in their prose, which lives in the content dictionaries. One
 * component means the call to action, the ad placement and the heading structure cannot
 * drift apart between them, in any of four languages.
 */

type UseCaseKey = 'groupTrip' | 'bachelorette' | 'groupGift';

function useCase(key: UseCaseKey, locale: ReturnType<typeof useLocale>): UseCasePage {
  return getContent(locale)[key];
}

function UseCaseView({ contentKey }: { contentKey: UseCaseKey }) {
  const c = useCase(contentKey, useLocale());

  return (
    <>
      <section className="section">
        <div className="section__inner section__inner--narrow prose">
          <h1 className="section__title">{c.heading}</h1>
          <p className="section__lede">{c.lede}</p>
          <Blocks blocks={c.blocks} />
        </div>
      </section>

      <UseCaseCta title={c.ctaTitle} body={c.ctaBody} />
      <AdSlot slot="use-case-footer" />
    </>
  );
}

export function GroupTripBudget() {
  return <UseCaseView contentKey="groupTrip" />;
}

export function BacheloretteBudget() {
  return <UseCaseView contentKey="bachelorette" />;
}

export function GroupGiftBudget() {
  return <UseCaseView contentKey="groupGift" />;
}
